(ns story-builder.util.date-time
  (:require
   [cljs-time.core :as t]
   [cljs-time.format :as tf]
   [clojure.string :as str])
  (:import
   [goog.date DateTime]))

(def iso-date-format (tf/formatter "yyyy-MM-dd"))
(def date-format (tf/formatter "dd MMMM, yyyy"))
(def date-time-format (tf/formatter "yyyy-MM-dd HH:mm"))

(defn date-time [d]
  (t/date-time (.getFullYear d)
               (inc (.getMonth d))
               (.getDate d)
               (.getHours d)
               (.getMinutes d)
               (.getSeconds d)))

(defn date-time-utc [d]
  (.UTC js/Date
        (.getFullYear d)
        (.getMonth d)
        (.getDate d)
        (.getUTCHours d)
        (.getUTCMinutes d)))

(defn format-date
  ([d] (format-date d date-format {}))
  ([d format] (format-date d format {}))
  ([d format {:keys [local? timestamp?]}]
   (when d
     (let [dt (cond-> (if (string? d)
                        (DateTime/fromIsoString d)
                        (DateTime/fromTimestamp d))
                local?
                (t/to-default-time-zone))]
       (str (tf/unparse format dt)
            (when timestamp?
              (str " " (-> js/Intl .DateTimeFormat .resolvedOptions .-timeZone))))))))

(defn today? [d]
  (letfn [(date-string [d]
            (first (str/split #":" (str d))))]
    (= (date-string d) (date-string (t/today)))))

(defn serialize-date
  "Serialize a cljs-time date to ISO string (YYYY-MM-dd format)"
  [date]
  (when date
    (tf/unparse iso-date-format date)))

(defn deserialize-date
  "Deserialize an ISO string to cljs-time date"
  [date-str]
  (when (and date-str (string? date-str))
    (try
      (tf/parse iso-date-format date-str)
      (catch js/Error _ nil))))
